import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';

const useCheckImage = (checkImage, category, code, saveStatus, uppyId) => {
  useEffect(() => {
    if (saveStatus === states.SUCCESS) {
      checkImage(category, code, uppyId);
    }
  }, [saveStatus]);
};

export default {
  useCheckImage,
};
